import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    inputDiv: {
        backgroundColor: '#E5F5FC',
        marginTop: '10px !important',
        borderRadius: '12px',
        width: '100% !important',
        marginLeft: '0px !important'
    },
    gridClass: {
        backgroundColor: 'white',
        border: '0px !important',
        margin: '10px 0px !important',
        height: '100%',
        width: '100%',
        fontSize: '13px !important',
        padding: '15px'
    },
    inputHeading: {
        color: '#4E4E4E',
        fontSize: '22px',
        fontWeight: '600'
    },
    inputParagraph: {
        color: '#4E4E4E',
        fontSize: '13px',
        paddingTop: '5px !important'
    },
    noBorder: {
        border: '0px !important'
    },
    inputField: {
        backgroundColor: '#fff',
        marginBottom: '20px',
        width: '60%',
        '@media (max-width: 960px)': {
            width: '98%'
        }
    },
    fontSizeInput: {
        fontSize: '14px !important'
    },
    inputButton: {
        backgroundColor: '#56C4FE !important',
        color: '#fff !important',
        height: '30px',
        width: '20%',
        borderRadius: '2px !important'
    },
    tableContentWrapper: {
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
        marginBottom: '80px',
        '& .MuiDataGrid-main .MuiDataGrid-columnsContainer': {
            overflow: 'hidden !important',
            border: '1px solid #E9EBF0 !important',
            borderRadius: '8px',
            minHeight: '50px !important',
            maxHeight: '50px !important'
        }
    },
    nameIcon: {
        width: '18px !important',
        height: '18px !important'
    },
    textRight: {
        position: 'relative',
        bottom: '8px'
    },
    textRightHeader: {
        bottom: '8px'
    },
    customPagination: {
        '& .MuiPagination-root': {
            paddingRight: '25px',
            paddingBottom: '8px'
        },
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
            {
                display: 'none'
            },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
            {
                margin: '0px 5px'
            }
    },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '22px'
    },
    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    }
}));
